import useToast from "@casino/legacy/client/hooks/useToast";
import useAppContext from "@casino/legacy/shared/context/AppContext/useAppContext";
import type { GameFragment } from "@workspace/casino_core/fragments/GameFragment";
import { useToggleFavouriteMutation } from "@workspace/casino_core/mutations/ToggleFavouriteMutation.client";
import { useCallback, useState } from "react";

// `isFavourite` is per user, so queries select it next to the shared fragment.
type Game = Pick<GameFragment, "id"> & { isFavourite?: boolean };

const useFavouriteGame = (game?: Game) => {
  const { showToast } = useToast();
  const [isFavourite, setIsFavourite] = useState(Boolean(game?.isFavourite));
  const [toggleFavourite] = useToggleFavouriteMutation();
  const { translations } = useAppContext();

  const handleClick = useCallback(async () => {
    if (game) {
      const { data } = await toggleFavourite({ gameId: game.id });
      const errors = data?.casinoToggleFavourite?.errors;
      if (!errors) {
        const favourite =
          data?.casinoToggleFavourite?.favouriteGameNode?.isFavourite;
        const translateId = favourite
          ? "casino.game_is_added_to_favourites"
          : "casino.game_is_removed_from_favourites";
        setIsFavourite(!!favourite);
        showToast({
          message: translations[translateId],
          variant: "success",
          timeout: 3000,
        });
        // Lists showing this game (the favourites page) update from the event.
        window.dispatchEvent(
          new CustomEvent("favouriteToggle", {
            detail: { gameId: game.id, isFavourite: !!favourite },
          }),
        );
      }
    }
  }, [game, showToast, toggleFavourite, translations]);

  return {
    isFavourite,
    handleClick,
  };
};
export default useFavouriteGame;
